import React from 'react'

import { ErrorBox } from '../style'
import DatabaseField from '../DatabaseField'
import {
    AddButton,
    AddButtonIcon,
    AddForm,
    FormActions,
    FormGrid,
    FormHeader,
    FormSubtitle,
    FormTitle,
} from './style'
import { useDatabaseAddForm } from './useDatabaseAddForm'

const DatabaseAddForm = () => {
    const {
        selectedTable,
        formData,
        currentFields,
        referenceOptions,
        referencesLoading,
        adding,
        addError,
        handleFieldChange,
        handleSubmit,
    } = useDatabaseAddForm()

    return (
        <AddForm onSubmit={handleSubmit}>
            <FormHeader>
                <div>
                    <FormTitle>Добавить запись</FormTitle>
                    <FormSubtitle>
                        Заполните поля и добавьте новую строку в выбранную таблицу.
                    </FormSubtitle>
                </div>
            </FormHeader>

            <FormGrid>
                {Object.keys(currentFields).map((field) => (
                    <DatabaseField
                        key={field}
                        field={field}
                        value={formData[field]}
                        onChange={handleFieldChange}
                        selectedTable={selectedTable}
                        referenceOptions={referenceOptions}
                        referencesLoading={referencesLoading}
                    />
                ))}
            </FormGrid>

            {addError && <ErrorBox>{addError}</ErrorBox>}

            <FormActions>
                <AddButton type="submit" disabled={adding || referencesLoading}>
                    <AddButtonIcon>＋</AddButtonIcon>
                    {adding ? 'Добавление...' : 'Добавить запись'}
                </AddButton>
            </FormActions>
        </AddForm>
    )
}

export default DatabaseAddForm
